import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Card,
  CardHeader,
  CardImg,
  CardBody,
  CardTitle,
  CardText,
} from 'reactstrap';
import {
  XCircle,
  CaretCircleDoubleRight,
  CaretCircleDoubleLeft,
  CheckCircle,
} from 'phosphor-react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import api from '../../api/api';
import Cookies from 'universal-cookie';
import { processError } from '../../lib/lib';
const cookies = new Cookies();

class TutorialModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      steps: [{ id: 0, img: '', title: '', content: '' }],
      activeStep: 0,
      isOpen: true,
      // eslint-disable-next-line no-undef
      imageUrl: process.env.REACT_APP_IMAGEURL,
    };
    this.toggle = this.toggle.bind(this);
    this.changeStep = this.changeStep.bind(this);
    this.pass = this.pass.bind(this);
  }

  pass() {
    cookies.set('isNew', false, { path: '/' });
    this.setState({ isOpen: false });
  }

  toggle() {
    this.setState({ isOpen: !this.state.isOpen });
  }

  changeStep(step) {
    this.setState({ activeStep: this.state.activeStep + step });
  }

  getTrainingAssistant(data) {
    return new Promise((resolve, reject) => {
      api
        .getTrainingAssistant(data)
        .then((res) => resolve(res))
        .catch((e) => reject(e));
    });
  }

  async componentWillMount() {
    const token = cookies.get('accessToken');
    const lang = this.props.i18n.language;
    this.getTrainingAssistant({ token, lang })
      .then(({ data }) => this.setState({ steps: data }))
      .catch((e) => processError(e, this.props.history));
  }

  render() {
    const { t } = this.props;
    return (
      <Modal
        isOpen={this.state.isOpen}
        toggle={this.toggle}
        className="tutorial-modal"
      >
        <ModalHeader>
          <span className="title xl-font-size">{t('tutorial-title')}</span>
          <Button className="skip-btn" onClick={this.pass}>
            <XCircle size={20} className="icon" />
            <span className="sm-font-size text">{t('tutorial-skip')}</span>
          </Button>
        </ModalHeader>
        <ModalBody>
          <div className="selectors">
            {this.state.steps.map(({ id }, index) => (
              <div
                key={`step-${id}-${index}`}
                className={`step-selector ${
                  this.state.activeStep === index && 'active'
                }`}
                onClick={() => this.setState({ activeStep: index })}
              ></div>
            ))}
          </div>
          {this.state.steps[this.state.activeStep] ? (
            <Card>
              <CardHeader>
                <CardImg
                  src={
                    this.state.steps[this.state.activeStep].image
                      ? `${this.state.imageUrl}/${
                          this.state.steps[this.state.activeStep].image
                        }`
                      : 'data:,'
                  }
                  alt=""
                />
              </CardHeader>
              <CardBody>
                <CardTitle className="md-font-size">
                  {this.state.steps[this.state.activeStep].title}
                </CardTitle>
                <CardText
                  className="sm-font-size"
                  dangerouslySetInnerHTML={{
                    __html: this.state.steps[this.state.activeStep].content,
                  }}
                ></CardText>
                <div className="actions">
                  {this.state.activeStep > 0 && (
                    <Button
                      className="action-btn"
                      onClick={() => this.changeStep(-1)}
                    >
                      <CaretCircleDoubleLeft className="icon" size={20} />
                      <span className="text sm-font-size">
                        {t('tutorial-prev')}
                      </span>
                    </Button>
                  )}
                  {this.state.activeStep < this.state.steps.length - 1 && (
                    <Button
                      className="action-btn"
                      onClick={() => this.changeStep(1)}
                    >
                      <CaretCircleDoubleRight className="icon" size={20} />
                      <span className="text sm-font-size">
                        {t('tutorial-next')}
                      </span>
                    </Button>
                  )}
                  {this.state.activeStep === this.state.steps.length - 1 && (
                    <Button className="action-btn" onClick={this.pass}>
                      <CheckCircle className="icon" size={20} />
                      <span className="text sm-font-size">
                        {t('tutorial-complete')}
                      </span>
                    </Button>
                  )}
                </div>
              </CardBody>
            </Card>
          ) : (
            ''
          )}
        </ModalBody>
      </Modal>
    );
  }
}

TutorialModal.propTypes = {
  t: PropTypes.func,
  history: PropTypes.object,
  i18n: PropTypes.object,
};

export default withTranslation()(TutorialModal);



// WEBPACK FOOTER //
// ./src/components/Main/TutorialModal.jsx